<template>
  <div class="admin-package-container">
    <div class="header">
      <div class="title">{{ $t('package') }} ({{ count }})</div>
      <RouterLink class="main-button" to="/admin/package/add">
        {{ $t('addPackage') }}
      </RouterLink>
    </div>

    <MonitoringTable :set-count="setCount" :is-admin="true" />
  </div>
</template>

<script>
import MonitoringTable from '@/components/tables/MonitoringTable';

export default {
  components: { MonitoringTable },

  data() {
    return {
      count: 0,
    };
  },

  methods: {
    setCount(count) {
      this.count = count;
    },
  },
};
</script>

<style scoped lang="scss">
@use '@/styles/colors.scss';
@use '@/styles/responsive.scss';
@use '@/styles/fonts.scss';
.admin-package-container {
  .header {
    margin: 60px 0 0;
    display: flex;
    justify-content: space-between;
    .title {
      display: flex;
      align-items: flex-end;
      font-weight: 500;
      font-size: 20px;
    }
    .main-button {
      max-width: 200px;
      padding: 0;
    }
  }
}
</style>
